import { Grid2 } from "@mui/material";
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { MenuItem, Typography, Button, List, ListItem, TextField, InputAdornment, Collapse, Select } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import './transaction.css'
import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';
import { useDispatch, useSelector } from "react-redux";
import { getWalletList } from "../../Actions/walletListAction";
import QRCode from "react-qr-code";
import { ToastError, ToastInfo, ToastSuccess } from "../../CustomToaster/CustomToaster";
import { createDeposit } from "../../Services/wallet";
import { InputError } from "../Errors/ErrorText";

// Notes box
const NotesBox = styled(Box)({
    background: 'linear-gradient(90deg, #9e5e1034 0%, #f8bb363f 25%, #f8ea513a 53.71%, #e89b023d 78.37%, #8746003a 100%)',
    borderRadius: '12px',
    padding: '16px',
    marginTop: '20px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.08)'
});

const Icon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="23"
        height="23"
        viewBox="0 0 23 23"
        fill="none"
        style={{ marginRight: 12 }}
    >
        <path
            d="M11.8366 4.77149C10.2905 4.76889 8.35339 5.2575 6.44238 6.25209C4.53441 7.24669 3.0221 8.54965 2.13435 9.82221C1.24617 11.0904 1.00599 12.2718 1.44291 13.1144C1.88027 13.9526 2.98606 14.4347 4.53615 14.4347C6.08624 14.439 8.02331 13.9483 9.92998 12.958C11.841 11.9634 13.3524 10.6561 14.2384 9.38789C15.1288 8.11967 15.3633 6.93832 14.929 6.09574C14.4903 5.2575 13.3872 4.77149 11.8366 4.77149ZM15.8281 7.82434C15.676 8.48885 15.346 9.17073 14.8812 9.83524C13.8997 11.2381 12.297 12.6062 10.2905 13.6486C8.2839 14.6953 6.24694 15.2208 4.53571 15.2208C3.72788 15.2208 2.97911 15.0992 2.34804 14.843L2.80798 15.729C3.24578 16.5716 4.34852 17.0537 5.89948 17.0537C7.45 17.0537 9.38708 16.5672 11.2937 15.5726C13.2048 14.5824 14.7162 13.2751 15.6022 12.0025C16.4882 10.7343 16.7314 9.55293 16.2928 8.71469L15.8281 7.82434ZM17.0789 8.55399C17.5653 9.71363 17.1744 11.1252 16.245 12.4499C15.4241 13.6269 14.1689 14.7691 12.6141 15.7246C13.0962 15.7768 13.6 15.8028 14.1125 15.8028C16.2624 15.8028 18.2081 15.3424 19.5806 14.6258C20.9574 13.9092 21.7131 12.971 21.7131 12.0242C21.7131 11.0774 20.9574 10.1393 19.5806 9.42264C18.8813 9.05781 18.0301 8.75813 17.0789 8.55399ZM21.7131 13.9743C21.2701 14.4912 20.662 14.9472 19.9454 15.3207C18.4253 16.1112 16.3753 16.5846 14.1125 16.5846C13.1917 16.5846 12.3057 16.5064 11.4762 16.3587C10.4685 16.8669 9.45657 17.2448 8.48369 17.4923C8.53581 17.5227 8.58792 17.5488 8.64439 17.5792C10.0168 18.2958 11.9626 18.7562 14.1125 18.7562C16.2624 18.7562 18.2081 18.2958 19.5806 17.5792C20.9574 16.8626 21.7131 15.9244 21.7131 14.9776V13.9743Z"
            fill="url(#paint0_linear_269_7533)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_269_7533"
                x1="21.7131"
                y1="11.7638"
                x2="1.23047"
                y2="11.7638"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0.19" stopColor="#DA9B31" />
                <stop offset="0.795" stopColor="#DA9B31" />
            </linearGradient>
        </defs>
    </svg>
);

const listItems = [
    'Select your preferred network from the dropdown.',
    'Enter the amount you want to deposit.',
    'Click on "Get Address" to generate your deposit address and QR code.',
    'Send the exact deposit amount to the generated address by scanning the QR code or copying the address.',
    'After completing the transfer, upload the transaction proof (screenshot/slip).',
    'Enter the Transaction ID (Transaction Hash) of your crypto transfer.',
    'Click on Submit to proceed with verification.',
    'Once the admin verifies your transaction, the deposited amount will be credited to your wallet.'
];

function Deposit() {
    const navigate = useNavigate();
    const [colapse, setcolapse] = useState(false);
    const [copiedIndex, setCopiedIndex] = useState(null);
    const handleCopy = (value, index) => {
        navigator.clipboard.writeText(value);
        setCopiedIndex(index);
        // alert('Copied Successful')
        ToastSuccess({ message: 'Copied Successful', icon: false })
        setTimeout(() => setCopiedIndex(null), 1500);
    };

    // custom code
    const dispatch = useDispatch();
    const { walletListData, walletListStatus } = useSelector((state) => state.walletList)
    const hasFetchedWalletList = useRef(false);
    const [walletList, setWalletList] = useState([])
    const [depositDetail, setDepositDetail] = useState({
        network: '',
        address: '',
        amount: '',
        slip: null,
        coin: '',
        minAmount: 0,
        maxAmount: 0,
        txHash: ''
    });

    const [depositError, setDepositError] = useState({
        network: '',
        address: '',
        amount: '',
        slip: '',
        txHash: ''
    })
    const [selectedImage, setSelectedImage] = useState(null);
    const [load, setLoad] = useState(false)

    useEffect(() => {
        if (!walletListData && !hasFetchedWalletList?.current) {
            dispatch(getWalletList());
            hasFetchedWalletList.current = true;
        }

    }, [walletListData])

    useEffect(() => {
        if (walletListStatus == true) {
            if (walletListData?.result?.length > 0) {
                setWalletList(walletListData?.result)
                setDepositDetail((prev) => ({
                    ...prev,
                    network: walletListData?.result[0]?.network,
                    address: walletListData?.result[0]?.address,
                    coin: walletListData?.result[0]?.coin,
                    minAmount: walletListData?.result[0]?.minAmount,
                    maxAmount: walletListData?.result[0]?.maxAmount
                }))
            }
            else {
                setWalletList([])
            }
        }
        else {
            setWalletList([])
        }

    }, [walletListStatus, walletListData])

    const handleChangeFormInput = (e) => {
        const name = e.target.name;
        let value = e.target.value;

        if (name === "amount") {
            const regex = /^\d{0,8}(\.\d{0,2})?$/;

            if (!regex.test(value) && value !== "") {
                return; // stop if invalid
            }
        }

        setDepositDetail((prev) => ({
            ...prev,
            [name]: value,
        }));

        setDepositError((prev) => ({
            ...prev,
            [name]: "",
        }));
    };


    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setDepositError({
            ...depositError,
            slip: ''
        })

        const validTypes = ["image/jpeg", "image/jpg", "image/png"];
        const maxSizeInBytes = 1 * 1024 * 1024; // 1 MB

        // Validate file type
        if (!validTypes.includes(file.type)) {
            ToastError({ message: "Only JPEG, JPG, or PNG files are allowed." });
            return;
        }

        // Validate file size
        if (file.size > maxSizeInBytes) {
            ToastError({ message: "File size must be 1 MB or less." });
            return;
        }

        const imageUrl = URL.createObjectURL(file);
        setSelectedImage(imageUrl);

        setDepositDetail({
            ...depositDetail,
            slip: file,
        });
    };

    const handleSubmit = async () => {
        const errors = {};

        if (!depositDetail.slip) errors.slip = "Upload the slip";
        if (!depositDetail.network) errors.network = "Select the network";
        if (!depositDetail.amount) errors.amount = "Amount is required";
        if (!depositDetail.txHash) errors.txHash = "Transaction Hash is required";

        const amount = Number(depositDetail?.amount);
        const min = Number(depositDetail?.minAmount);
        const max = Number(depositDetail?.maxAmount);

        if (amount < min) {
            errors.amount = `Amount must be greater than or equal to ${min} ${depositDetail?.coin}`;
        } else if (amount > max) {
            errors.amount = `Amount must be less than or equal to ${max} ${depositDetail?.coin}`;
        }

        if (Object.keys(errors).length > 0) {
            setDepositError(errors);
            return;
        }

        setDepositError({}); // clear errors if no issues

        try {
            const form = new FormData();




            // Append image if changed
            if (selectedImage) {
                form.append("image", depositDetail?.slip);
            }
            form.append('coin', depositDetail?.coin);
            form.append('network', depositDetail?.network);
            form.append('address', depositDetail.address);
            form.append('amount', depositDetail.amount)
            form.append('txHash', depositDetail.txHash)

            // Skip if no changes
            if (form.entries().next().done) {
                ToastInfo({ message: "Your profile is already up to date." });
                return;
            }
            setLoad(true)
            const response = await createDeposit(form)

            if (response.status === 200 && response.data.success) {
                ToastSuccess({ message: response.data.message });
                setLoad(false)
                navigate('/portfolio')

            } else {
                ToastError({ message: response.data.message });
                setLoad(false)


            }
        } catch (err) {
            ToastError({ message: "Failed to update" });
            setLoad(false)

        }
    };
    return (
        <Grid2 container spacing={2} className="mt-20">
            <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} >
                <div className="display-2 mb-10" >
                    <h2 className="gold-color">Deposit</h2>
                </div>
            </Grid2>
            <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }} className="card-box" >

                <Grid2 container spacing={2} className="">

                    <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} >
                        <div className="input-common  mt-20">
                            <label>Coin</label>

                            <div className="mt-10" style={{ display: 'flex', flexDirection: 'row' }}>
                                <TextField
                                    name="txHash"
                                    fullWidth
                                    value={depositDetail?.coin}
                                    placeholder="Enter the transaction id"
                                    disabled
                                    sx={{

                                        "& .MuiInputBase-input.Mui-disabled": {
                                            WebkitTextFillColor: "#fff",
                                        },
                                    }}
                                />
                            </div>

                        </div>


                        <div className="input-common  mt-20">
                            <label>Select Network</label>
                            <div className="mt-10">
                                <Select
                                    fullWidth
                                    value={depositDetail?.network || ""}
                                    onChange={(e) => {
                                        const selectedNetwork = e.target.value;

                                        const selectedItem = walletList?.find(
                                            (item) => item.network === selectedNetwork
                                        );

                                        setDepositDetail((prev) => ({
                                            ...prev,
                                            network: selectedNetwork,
                                            address: selectedItem?.address || "",
                                            maxAmount: selectedItem?.maxAmount,
                                            minAmount: selectedItem?.minAmount
                                        }));
                                    }}
                                    variant="standard"
                                    disableUnderline
                                    name="network"
                                >
                                    {walletList?.map((item, index) => (
                                        <MenuItem value={item.network} key={index}>
                                            {item.network}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </div>
                            <InputError error={depositError?.network} />

                        </div>

                        {
                            !colapse &&
                            <div className="blu-btn display-3 mt-20">
                                <Button
                                    onClick={() => setcolapse(prev => !prev)}
                                >
                                    Get Address
                                </Button>
                            </div>
                        }
                        <Collapse in={colapse}>
                            <div className="input-common adornment-input">
                                <label>Address</label>

                                <div className="mt-10">
                                    <TextField
                                        name="address"
                                        fullWidth
                                        value={depositDetail?.address}
                                        placeholder="Address"
                                        // defaultValue="0xB18A9019fD98751d0B8f1A9a5Ff8cccE294FE81b"
                                        InputProps={{
                                            endAdornment: (
                                                <div onClick={() => handleCopy(depositDetail?.address)}>
                                                    <InputAdornment position="start">
                                                        <ContentCopyRoundedIcon sx={{ marginRight: "10px" }} />
                                                    </InputAdornment>
                                                </div>
                                            ),
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="display-3 mt-20">
                                <div className="card-box ">

                                    <QRCode
                                        // size={256}
                                        style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                                        value={depositDetail?.address}
                                        viewBox={`0 0 256 256`}
                                    />

                                </div>
                            </div>
                        </Collapse>

                    </Grid2>


                </Grid2>


                {
                    colapse &&
                    <>
                        <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} >
                            <div className="input-common adornment-input" >
                                <label>Amount</label>

                                <div className="mt-10" style={{ display: 'flex', flexDirection: 'row' }}>
                                    <TextField
                                        name="amount"
                                        fullWidth
                                        value={depositDetail?.amount}
                                        placeholder="Enter the amount"
                                        onChange={handleChangeFormInput}
                                    />
                                    <Typography sx={{ marginLeft: 2, marginTop: 1 }}>{depositDetail?.coin}</Typography>
                                </div>
                                <InputError error={depositError?.amount} />
                            </div>
                            <div className="input-common adornment-input" >
                                <label>Transaction Hash</label>

                                <div className="mt-10" style={{ display: 'flex', flexDirection: 'row' }}>
                                    <TextField
                                        name="txHash"
                                        fullWidth
                                        value={depositDetail?.txHash}
                                        placeholder="Enter the transaction id"
                                        onChange={handleChangeFormInput}
                                    />
                                </div>
                                <InputError error={depositError?.txHash} />
                            </div>

                        </Grid2>
                        <div>
                            <input
                                type="file"
                                id="file-input"
                                className="upload-bt"
                                style={{ display: 'none' }}
                                onChange={handleImageChange}
                                accept="image/*"
                            />

                            {

                                selectedImage &&
                                <div className="upload-img" style={{ border: "1px solid #F8BC36", borderRadius: "8px", display: 'flex', justifyContent: "center", width: '200px' }}>
                                    <div>
                                        <img
                                            alt="Selected"
                                            style={{ width: "150px", height: '150px', objectFit: 'cover' }}
                                            src={selectedImage}
                                        />
                                    </div>
                                </div>

                            }
                        </div>
                        <div className="blu-btn display-3 mt-20">
                            <label htmlFor="file-input">
                                <Button onClick={() => document.getElementById('file-input').click()}>Upload Slip</Button>
                            </label>
                        </div>
                        <div className="display-3">
                            <InputError error={depositError?.slip} />

                        </div>

                        <div className="blu-btn display-3 mt-20">
                            {
                                load === true ?
                                    <Button className="" disabled>Progressing</Button>
                                    :
                                    <Button className="" onClick={handleSubmit}>Submit</Button>

                            }
                        </div>
                    </>
                }
            </Grid2>

            <Grid2 item size={{ xs: 12, sm: 12, md: 11, lg: 6, xl: 6 }}>
                <NotesBox sx={{ marginTop: '0', height: '93%' }}>
                    <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                        Notes
                    </Typography>
                    <List disablePadding sx={{ paddingLeft: '1.2rem' }}>
                        {listItems.map((item, index) => (
                            <ListItem
                                key={index}
                                disableGutters
                                sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}
                            >
                                <Icon />
                                <Typography variant="body2" fontWeight="bold">
                                    {item}
                                </Typography>
                            </ListItem>
                        ))}
                    </List>
                </NotesBox>
            </Grid2>
        </Grid2>
    );
}

export default Deposit;
